module.exports = __webpack_public_path__ + "static/media/InfoLarge.2aef1d54.svg";